/* eslint-disable */
import Vuex from 'vuex';
import Vue from 'vue'
import { vuexOidcCreateStoreModule } from 'vuex-oidc';


import { oidcSettings } from '../config/oidc';
import ClientStore from './modules/client'
import OidcStore from './modules/oidc'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
const store = new Vuex.Store({
    plugins: [createPersistedState({
        paths:['client']
    })],
    modules : {
        client: ClientStore,
        oidc: OidcStore
    }
});

export default store;
